import type { CSS } from '@grupoboticario/flora-react'

export const cpfInputBoxCss: CSS = {
  width: '100%',
  '@desktop': { width: '30%' }
}

export const linkTextCss: CSS = {
  cursor: 'pointer',
  textDecoration: 'underline'
}
